"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchPlayerStatus = void 0;
var MatchPlayerStatus;
(function (MatchPlayerStatus) {
    /**
     * User invited to game by game creator
     */
    MatchPlayerStatus["Invited"] = "invited";
    /**
     * User requested join to open game
     */
    MatchPlayerStatus["Requested"] = "requested";
    /**
     * User declined invitation request in private the game
     */
    MatchPlayerStatus["Declined"] = "declined";
    /**
     * User accepted to join to the game
     */
    MatchPlayerStatus["Ready"] = "ready";
    /**
     * User finished the game session and has results
     */
    MatchPlayerStatus["Played"] = "played";
})(MatchPlayerStatus = exports.MatchPlayerStatus || (exports.MatchPlayerStatus = {}));
//# sourceMappingURL=match-player-status.js.map